// src/helpers/storage.ts
var InMemoryStorage = class {
  constructor() {
    this.prismeStorageMap = /* @__PURE__ */ new Map();
  }
  prismeStorageMap;
  clear() {
    this.prismeStorageMap.clear();
  }
  getItem(key) {
    return this.prismeStorageMap.get(key) || null;
  }
  key(index) {
    return Array.from(this.prismeStorageMap.values())[index];
  }
  removeItem(key) {
    this.prismeStorageMap.delete(key);
  }
  setItem(key, value) {
    this.prismeStorageMap.set(key, value);
  }
  get length() {
    return this.prismeStorageMap.size;
  }
};

export { InMemoryStorage };
//# sourceMappingURL=chunk-W7YKW4WJ.js.map
//# sourceMappingURL=chunk-W7YKW4WJ.js.map